// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__rUD1g","navbarScrollCustom":"carroFicha_navbarScrollCustom__dn+DP","rectangle":"carroFicha_rectangle__9KkdX"};